"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTH_DAY_DAY_TEXT_FORMAT = exports.DEFAULT_DATE_FORMAT = exports.dayTexts = exports.SEARCH_PARAMS_DATE_FORMAT = void 0;
exports.SEARCH_PARAMS_DATE_FORMAT = 'YYYY.MM.DD.';
exports.dayTexts = ['일', '월', '화', '수', '목', '금', '토'];
exports.DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
exports.MONTH_DAY_DAY_TEXT_FORMAT = 'MM.DD.ddd';
